import { render, staticRenderFns } from "./CrewInfo.vue?vue&type=template&id=4297c856&scoped=true"
import script from "./CrewInfo.vue?vue&type=script&lang=js"
export * from "./CrewInfo.vue?vue&type=script&lang=js"
import style0 from "./CrewInfo.vue?vue&type=style&index=0&id=4297c856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297c856",
  null
  
)

export default component.exports